<template>
    <div>
        <h2 class="profile__title">video links</h2>
        <draggable v-model="form.listOfLinks" @end="onDragEnd">
        <div class="form-group mb-3" v-for="(link, index)  in form.listOfLinks" :key="index">
            <label for="" class="form-label">Video link {{ index + 1}}</label>
            <div class="new-line">
                <input
                    type="text"
                    v-model="link.link"
                    class="form-control pl-4"
                    placeholder="Link goes here"
                >
                <button type="button" class="line-delete" @click="deleteLink(index, link.id)">
                    <svg width="12" height="12" aria-hidden="true">
                        <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
                    </svg>
                </button>
            </div>
        </div>
        </draggable>
        <div class="add-link mt-4 mb-5">
            <a href="javascript:void(0)" @click="addNewLink">+ Add  Link</a>
        </div>

        <BaseButtons
            :on-save="saveLinksForVideo"
            :on-cancel="reloadPage"
        />
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import BaseButtons from "./BaseButtons.vue";
import AdminService from "../../services/AdminService";
import {mapState} from "pinia";
import {useArtistStore} from "../../stores/ArtistStore";
import draggable from "vuedraggable";
import ModalHandler from "../../mixins/ModalHandler";

export default defineComponent({
    name: "VideoLinks",
    components: {draggable, BaseButtons},
    mixins: [ModalHandler],
    props: {
      savedLinks: Array
    },
    data() {
        return {
            form: {
                listOfLinks: [],
                deleted: [],
            },

        }
    },
    computed: {
        ...mapState(useArtistStore, {
            artistId: 'artistId'
        })
    },
    mounted() {
        this.form.listOfLinks = this.savedLinks
    },
    methods: {
        isValidHttpsUrl(url) {
            try {
                const parsed = new URL(url);
                return parsed.protocol === "https:";
            } catch (_) {
                return false;
            }
        },
        async saveLinksForVideo() {
            const invalid = this.form.listOfLinks.find(item => !this.isValidHttpsUrl(item.link));
            if (invalid) {
                this.$showErrorMessage("Please enter valid HTTPS links only");
                return;
            }
            try {
                await AdminService.saveLinksForVideo(this.artistId, this.form)
                this.$showSuccessMessage('Information saved')
            } catch (error) {
                this.$showErrorMessage('Information not saved')
                console.error(error)
            }
        },
        deleteLink(index, id) {
            this.form.listOfLinks.splice(index, 1)
            if (id) {
                this.form.deleted.push(id)
            }
        },
        addNewLink() {
            this.form.listOfLinks.push({
                id: null,
                link: '',
                sortingOrder: null
            });
        },
        onDragEnd() {
            this.form.listOfLinks.forEach((item, index) => {
                item.sortingOrder = index + 1;
            });
        }
    }
})
</script>



<style scoped>

</style>
